export var sortFiltersByKeys = function (sortOrder) {
    return function (a, b) {
        // make sure any ids not in the sortOrder, gets sorted to the end of the list
        if (sortOrder.indexOf(a.id) === -1) {
            return 1;
        }
        if (sortOrder.indexOf(b.id) === -1) {
            return -1;
        }
        // sort according to sortOrder
        return sortOrder.indexOf(a.id) - sortOrder.indexOf(b.id);
    };
};
